import { render, staticRenderFns } from "./DetailDaily.vue?vue&type=template&id=b9a64140&scoped=true&"
import script from "./DetailDaily.vue?vue&type=script&lang=js&"
export * from "./DetailDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a64140",
  null
  
)

export default component.exports